let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dho0e")).then(() => parcelRequire('lxrg6'));